// extracted by mini-css-extract-plugin
export default {"list":"index_list_MDKzQ","img":"index_img_6l8w5"};